import React, { FC } from "react";
import styled from "styled-components";
import {
  tombac,
  Modal,
  ModalLayout,
  ModalHeader,
  ModalContent,
  ModalActions,
  Text,
  Button,
  Box,
  useToasts,
} from "tombac";
import { CopyIcon } from "tombac-icons";
import { UserProductSafe } from "./../legolandApi/legolandApiTypes";
import { renderProductIcon } from "../../icons";
import { ProductsApiKeys } from "./ProductsApiKeys";

export type LegolandNavbarApiKeyModalProps = {
  isOpen: boolean;
  products: UserProductSafe[] | undefined;
  setIsOpen: (isOpen: boolean) => void;
};

export const LegolandNavbarApiKeyModal: FC<LegolandNavbarApiKeyModalProps> = ({
  isOpen,
  products,
  setIsOpen,
}) => {
  const { addToast } = useToasts();

  return (
    <Modal isOpen={isOpen}>
      <ModalLayout $width="370u">
        <ModalHeader> Your API key</ModalHeader>
        <ModalContent variant="scrollable">
          {products && <ProductsApiKeys products={products} />}
          <Text fontWeight="bold">
            Read more about how to use API access on:
          </Text>
          <LinkStyled
            as="a"
            href="https://developer.tomtom.com/documentation#traffic-apis"
          >
            https://developer.tomtom.com/documentation#traffic-apis
          </LinkStyled>
        </ModalContent>
        <ModalActions>
          <Button onClick={() => setIsOpen(false)} variant="primary">
            Close
          </Button>
        </ModalActions>
      </ModalLayout>
    </Modal>
  );
};

const LinkStyled = styled(Text)`
  color: ${tombac.color("accent", 600)};
  &:hover {
    cursor: pointer;
  }
`;
